import { CategoryProducts } from './CategoryProducts';
import { IDesignCategory, IdiSeoData } from '../../interfaces';
import styles from './DesignCategory.module.css';
import { useState } from 'react';
import { DesignIdeaCategoryLongBody } from '../longBody/designICategoryDeaLongBody/DesignIdeaCategoryLongBody';


type props = {
    designCategoryData?: IDesignCategory;
    isSearch?: boolean;
    shortContent?: IdiSeoData;
}

export function DesignCategory({ designCategoryData, isSearch, shortContent }: props) {
    const _shortContent = (shortContent?.short_content || designCategoryData?.categoryProducts?.categoryMetaDetail?.shortContent) || ""
    const pagingNo = designCategoryData?.categoryProducts?.pagingData?.pageNo || 0;
    const [fullDesc, setFullDesc] = useState(false);
    return (
        <div className={`${styles.modulerBx} mb24`}>
            {
                !isSearch && <div className={styles.modularHeading}>
                    {!designCategoryData?.selectedAttributeSlug ? <h1 className={"font26 text222  " + styles.mainHeading}>{(pagingNo > 1 ? `Page ${pagingNo} - ` : '') + (shortContent?.heading || "")}</h1> :
                        <h1 className={"font26 text222  " + styles.mainHeading}>{designCategoryData?.categoryProducts.categoryMetaDetail && ((pagingNo > 1 ? `Page ${pagingNo} - ` : '') + designCategoryData.categoryProducts.categoryMetaDetail.heading)}</h1>}
                    <div className={`${styles.readMoreHeading} ${fullDesc && styles.active}`}>
                        {_shortContent && <p className={`font16 text666 ${styles.subHeading}`}>{_shortContent.capitalizeSentences()}</p>}
                        {_shortContent && <span onClick={() => setFullDesc(!fullDesc)}>read {fullDesc ? 'less' : 'more'}</span>}
                    </div>
                </div>
            }
            {
                designCategoryData && <CategoryProducts data={designCategoryData} />
            }
            {
                designCategoryData?.categoryProducts?.categoryMetaDetail?.longFormContent && <DesignIdeaCategoryLongBody seoData={{ long_form_content: designCategoryData?.categoryProducts?.categoryMetaDetail?.longFormContent, FAQ: designCategoryData?.categoryProducts?.categoryMetaDetail?.faqs }} />
            }
        </div>
    )
}